export const homeList = [
  { name: 'SERVICES', to: 'services' },
  { name: 'MISSIONS', to: 'missions' },
  { name: 'CLIENTS', to: 'clients' }
]
